import { Section, TitleAndDescription } from '@ferreri/prever-component-lib';
import { ContractEmptyState } from 'modules/contract/ContractEmptyState';

export const PetAssistanceBenefitContractEmptyState = () => {
  return (
    <Section>
      <TitleAndDescription
        title="Assistência Pet"
        description="Para ter direito a assistência pet você precisa ser associado ao Plano Multiassistência. Adquira um plano ou vincule o seu, caso já seja um associado. "
      />
      <ContractEmptyState />
    </Section>
  );
};
